/**
 * 配信モード（配信や録画のときに。合間の広告とお知らせを止める）。
 *
 * オンのあいだ：
 * - 合間の広告を出さない（AssistController.blockInterstitial。ごほうび広告は本人が押したときだけなので残す）
 * - トースト・吹き出し・ホーム画面に追加の案内を出さない（showToast と CSS の html[data-streamer]）
 * - 上部のスコアを大きめに出す（CSS）
 * - オンにした瞬間に、名場面の録画もオンにする（録画はあとで個別にオフにできる。2026-10-05 レビュー5）
 * 保存は設定（GameSettings.streamerMode）の中。
 */

export function applyStreamerMode(on: boolean): void {
  if (typeof document === 'undefined') return;
  if (on) document.documentElement.dataset.streamer = 'true';
  else delete document.documentElement.dataset.streamer;
}

export function isStreamerMode(): boolean {
  return typeof document !== 'undefined' && document.documentElement.dataset.streamer === 'true';
}

/**
 * 配信モードを切り替えたときに一緒に変える設定。
 * オンにしたら録画もオンにする（録画できない端末では何もしない）。オフにしても録画はそのまま。
 */
export function streamerModeChange(
  on: boolean,
  canRecord: boolean,
): { streamerMode: boolean; recordHighlights?: boolean } {
  return on && canRecord ? { streamerMode: true, recordHighlights: true } : { streamerMode: on };
}
